import { NextSeo } from "next-seo";
import Link from "next/link";
import { useRouter } from "next/router";
import { Col, Row } from "react-styled-flexboxgrid";
import styled from "styled-components";
import Public from "../../Layouts/Public";
import { ActionTitle } from "../../components/ActionWithHint";
import Heading from "../../components/Heading";
import PageSection from "../../components/PageSection";
import Spacer from "../../components/Spacer";
import { siteTitle } from "../../data/PublicSiteData";
import { trackPageView } from "../../includes/analytics";
import { device } from "../../theme/Breakpoints";
import { Color } from "../../theme/Color";

const StyledSignUpCol = styled(Col)`
  min-height: 15vh;

  @media ${device.mdAndWider} {
    min-height: 30vh;
  }
`;

const BusinessPage = () => {
  const router = useRouter();

  trackPageView("/business");

  return (
    <>
      <NextSeo
        title={`Business | ${siteTitle}`}
        description="Valmeego is a new way for destinations and visitors to connect directly, combined with a user-friendly multi-purpose tool for researching, planning and booking any trip."
      />
      <PageSection fullHeight={true} backgroundColor={Color.White}>
        <Row middle="xs">
          <Col xs={12}>
            <Heading centered fontColor={Color.Black} size={2}>
              <Spacer top={14} bottom={4}>
                What type of business?
              </Spacer>
            </Heading>
          </Col>
        </Row>

        <Row middle="xs">
          <Col xs={6}>
            <Row middle="xs">
              <Col xs={12}>
                <Spacer bottom={8}>
                  <ActionTitle color={Color.Black}>
                    <Link href="/business/accommodation">
                      <a>Accommodation</a>
                    </Link>
                  </ActionTitle>
                </Spacer>
              </Col>
            </Row>
            <Row middle="xs">
              <Col xs={12}>
                <Spacer bottom={8}>
                  <ActionTitle color={Color.Black}>
                    <Link href="/business/attractions-activities">
                      <a>Attractions & Activities</a>
                    </Link>
                  </ActionTitle>
                </Spacer>
              </Col>
            </Row>
            <Row middle="xs">
              <Col xs={12}>
                <Spacer bottom={8}>
                  <ActionTitle color={Color.Black}>
                    <Link href="/business/entertainment">
                      <a>Entertainment</a>
                    </Link>
                  </ActionTitle>
                </Spacer>
              </Col>
            </Row>
          </Col>
          <Col xs={6}>
            <Row middle="xs">
              <Col xs={12}>
                <Spacer bottom={8}>
                  <ActionTitle color={Color.Black}>
                    <Link href="/business/food-beverage">
                      <a>Food & Beverage</a>
                    </Link>
                  </ActionTitle>
                </Spacer>
              </Col>
            </Row>
            <Row middle="xs">
              <Col xs={12}>
                <Spacer bottom={8}>
                  <ActionTitle color={Color.Black}>
                    <Link href="/business/tour-operators">
                      <a>Tour Operator</a>
                    </Link>
                  </ActionTitle>
                </Spacer>
              </Col>
            </Row>
            <Row middle="xs">
              <Col xs={12}>
                <Spacer bottom={8}>
                  <ActionTitle color={Color.Black}>
                    <Link href="/business/transport">
                      <a>Transport</a>
                    </Link>
                  </ActionTitle>
                </Spacer>
              </Col>
            </Row>
          </Col>
        </Row>
      </PageSection>
    </>
  );
};

BusinessPage.Layout = Public;
BusinessPage.Title = "Valmeego - Locally and beyond";

export default BusinessPage;
